import { create } from "zustand";
import axiosInstance from '../../api/axiosInstance';

interface Field {
  type: string;
  value: string;
  link?: string;
}
interface Testimonial {
  title: string;
  description: string;
  image: string;
}

interface Section {
  id: number;
  section_name: string;
  payload: Record<string, Field>;
  loop_fields: Testimonial[];
}

interface HomeState {
  sections: Record<string, Section>;
  fetchZodiacContent: () => Promise<void>;
}

const useZodiacStore = create<HomeState>((set) => ({
  sections: {},
  fetchZodiacContent: async () => {
    try {
      const response = await axiosInstance.get("/cmsPages/zodiac");
      const formattedSections = response.data.pages.rows.reduce(
        (acc: Record<string, Section>, section: any) => {
          try {
            // Try to parse the payload
            const parsedPayload = JSON.parse(section.payload);
            const parsedPayload2 = JSON.parse(section.loop_fields);
            acc[section.section_name] = {
              id: section.id,
              section_name: section.section_name,
              payload: parsedPayload,
              loop_fields: parsedPayload2,
            };
          } catch (parseError) {
            console.log(section.payload);
            console.error("Error parsing payload for section:", section.section_name, parseError);
          }
          return acc;
        },
        {}
      );

      set({ sections: formattedSections });
    } catch (error) {
      console.error("Error fetching home content:", error);
    }
  },
}));


export default useZodiacStore;








